import React, { useState } from "react";
import { ModalBuilder, Table, useAuthClaims } from "@redriver/cinnamon";
import { getUser, updateUser } from "./actions";
import UserForm from "./UserForm";
import { TranslatedModal } from "features/../../../shared/components/modals";

const EditUser = ({
  as: As = Table.MenuItem,
  user,
  companyId,
  onSubmitted,  
  ...props
}) => {
  const [showAccessTree, setShowAccessTree] = useState(false);
  const { userArea } = useAuthClaims();
  return (
    <ModalBuilder
      withForm
      loadAction={getUser}
      loadParams={user.id}
      submitAction={updateUser}
      submitParams={{ userId: user.id, showAccessTree: showAccessTree }}
      onSubmitted={onSubmitted}
      renderTrigger={showModal => <As {...props} onClick={showModal}></As>}
      renderModal={(modalProps, formProps, state, events) => (
        <TranslatedModal.Edit
          {...modalProps}
          className="edit-user-modal"
          header={`Update User: ${user.firstName} ${user.lastName}`}
        >
          <UserForm
            setShowAccessTree={setShowAccessTree}
            showAccessTree={showAccessTree}
            formProps={formProps}
            isEditMode={true}
            loading={state.loading}
            companyId={companyId}
            userArea={userArea}
            userId={user.id}
          />
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default EditUser;
